import type { BillingQuoteStatus } from '@commenda/prisma';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

export type THubspotDealOption = {
  id: string;
  name: string;
  existingQuote: { id: string; status: BillingQuoteStatus } | null;
};

// Search HubSpot deals to anchor a deal-first quote (no Company in Commenda yet). Pass a null/empty
// query to skip the fetch (e.g. when the company anchor is selected instead).
export function useSearchHubspotDeals(query: string | null) {
  const trimmed = query?.trim();
  const { data, error, isLoading } = useSWR<THubspotDealOption[]>(
    trimmed
      ? `commenda-billing/quotes/deals/search?q=${encodeURIComponent(trimmed)}`
      : null,
    SWRFetcher({ method: 'GET' }),
    { dedupingInterval: 0 }
  );

  return { deals: data ?? [], error, isLoading };
}
